import { useCallback } from 'react'
import { Editor, Element as SlateElement } from 'slate'
import { useSlate } from 'slate-react'

import { BLOCK_FORMATS, CustomEditor } from '../../../interface/custom-types'

import { BaseButton, IBaseButton } from './BaseButton'

function isBlockActive(editor: CustomEditor, format: BLOCK_FORMATS, blockType = 'type') {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && n[blockType] === format,
    })
  )

  return !!match
}

export function BlockStyleButton(props: IBaseButton<BLOCK_FORMATS>) {
  const editor = useSlate()
  const callIsActive = useCallback(() => {
    return isBlockActive(editor, props.format)
  }, [])

  return <BaseButton {...props} callIsActive={callIsActive} />
}
